/** Single place for the offer numbers and the checkout link. */
export const offer = {
  productName: 'Badminton Class Ready',
  price: 27,
  anchor: 90,
  priceRise: 5,
  guaranteeDays: 7,
  checkoutUrl: 'https://badmintonclassready.impultienda.ar/checkout',
}
